import React, {
	memo,
	useEffect
} from 'react';

import { useUIAction } from '../../../contexts/UIContext';
import { Provider as CalendarProvider } from '../../../contexts/CalendarContext';
import { Provider as DashboardProvider } from '../../../contexts/DashboardContext';

import ActivityLog from './ActivityLog';

const Dashboard = () => {
	const {
		disableSidebar,
		setInfobar
	} = useUIAction();

	useEffect( () => {
		setInfobar( <span>Dashboard</span> );
		disableSidebar( true );
	}, [
		disableSidebar,
		setInfobar
	] );

	return (
		<DashboardProvider>
			<CalendarProvider>
				<ActivityLog />
			</CalendarProvider>
		</DashboardProvider>
	);
};

export default memo( Dashboard );
